import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { getCompanyPlans } from '../api/plan';
import './CampaignList.css';

const PlanListPage = () => {
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || `企業ID: ${companyId}`;
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlansData = async () => {
      try {
        const res = await getCompanyPlans(companyId);
        setPlans(res.plans || []);
      } catch (error) {
        console.error('プラン情報の取得に失敗:', error);
      }
    };
    fetchPlansData();
  }, [companyId]);

  return (
    <div className="listBody">
      <h2 className="listTitle">プラン一覧（{companyName}）</h2>
      <ul>
        {plans.length === 0 ? (
          <li>プランが登録されていません</li>
        ) : (
          plans.map((plan) => (
            <li
              key={plan.id}
              style={{
                marginBottom: '0.5rem',
                display: 'flex',
                borderBottom: '1px solid #ccc',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>
                {plan.name} ({plan.price_id})
              </span>

              <button
                onClick={() =>
                  navigate(
                    `/plans/${companyId}/edit/${plan.id}?companyName=${encodeURIComponent(companyName)}`
                  )
                }
                style={{
                  cursor: 'pointer',
                  backgroundColor: '#5BAF5E',
                  color: 'white',
                  border: '1px solid #ccc',
                  padding: '5px 10px',
                  borderRadius: '5px',
                }}
              >
                編集
              </button>
            </li>
          ))
        )}
      </ul>
      <button
        type="button"
        style={{
          marginTop: '2rem',
          padding: '10px 20px',
          fontWeight: 'bold',
        }}
        onClick={() => navigate('/campaignlist')}
      >
        企業管理に戻る
      </button>
    </div>
  );
};

export default PlanListPage;
